/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum SaasServiceName {
    OpenAI = 'OpenAI',
    Databricks = 'Databricks',
    Snowflake = 'Snowflake',
    CircleCI = 'CircleCI',
    Datadog = 'Datadog',
    Dropbox = 'Dropbox',
    Dynatrace = 'Dynatrace',
    Elastic = 'Elastic',
    Grafana = 'Grafana',
    IBM_Tencent = 'IBM_Tencent',
    Microsoft_Teams = 'Microsoft_Teams',
    New_Relic = 'New_Relic',
    Okta = 'Okta',
    SaasCustomTool = 'SaasCustomTool',
    Salesforce_Sales_Cloud = 'Salesforce_Sales_Cloud',
    Splunk = 'Splunk'
}
